import { render, staticRenderFns } from "./ConfirmCollege.vue?vue&type=template&id=2234a1da&scoped=true"
import script from "./ConfirmCollege.vue?vue&type=script&lang=js"
export * from "./ConfirmCollege.vue?vue&type=script&lang=js"
import style0 from "./ConfirmCollege.vue?vue&type=style&index=0&id=2234a1da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2234a1da",
  null
  
)

export default component.exports